import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useParams, useNavigate } from 'react-router-dom';
import './TIJSidebar.css';


import ZH from '../Pages/ZH';
import ZX1 from '../Pages/ZX1';
import ZX2 from '../Pages/ZX2';
import ZX4 from '../Pages/ZX4';
import TTO32I from './TTO32I';
import TTO53I from './TTO53I';
import TTO107I from './TTO107I';
import TTO128I from './TTO128I';

const TTOLayout = ({ mode }) => {
  // Use URL parameter or default to the provided mode or '32I&C-TTO'
  const { type } = useParams();
  const navigate = useNavigate();
  const [activeComponent, setActiveComponent] = useState(type || mode || '32I&C-TTO');
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  // Update URL when activeComponent changes
  useEffect(() => {
    navigate(`/thermal-transfer-printer/${activeComponent}`);
  }, [activeComponent, navigate]);

  // Handle component switching
  const handleComponentChange = (component) => {
    setActiveComponent(component);
    setIsSidebarOpen(false);
  };

  // Render the active component

  const renderActiveComponent = () => {
    switch (activeComponent) {
      case '32I&C-TTO':
        return <TTO32I/>;
      case '53I&C-TTO':
        return <TTO53I/>;
      case '107I&C-TTO':
        return <TTO107I/>;
      case '128I&C-TTO':
        return <TTO128I/>;
      default:
        return <TTO32I/>;
    }
  };

  return (
    <div className="page-container">
      <div className="content-wrap">
      
        {/* Mobile Navigation (Horizontal) */}
        <div className="mobile-nav">
          <button
            className={`nav-link ${activeComponent === '32I&C-TTO' ? 'active' : ''}`}
            onClick={() => handleComponentChange('32I&C-TTO')}
          >
            32 I & C TTO
          </button>
          <button
            className={`nav-link ${activeComponent === '53I&C-TTO' ? 'active' : ''}`}
            onClick={() => handleComponentChange('53I&C-TTO')}
          >
            53 I & C TTO         
             </button>
          <button
            className={`nav-link ${activeComponent === '107I&C-TTO' ? 'active' : ''}`}
            onClick={() => handleComponentChange('107I&C-TTO')}
          >
            107 I & C TTO
          </button>
          <button
            className={`nav-link ${activeComponent === '128I&C-TTO' ? 'active' : ''}`}
            onClick={() => handleComponentChange('128I&C-TTO')}
          >
            128 I & C TTO
          </button>
        </div>

        {/* Hamburger Menu Toggle Button (Visible on Small Screens) */}
        <button
          className="sidebar-toggle"
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
        >
          ☰
        </button>

        {/* Sidebar */}
        <div className={`sidebar ${isSidebarOpen ? 'open' : ''}`}>
        <div className="mb-3 ml-4 mt-3" style={{fontSize:"18px", fontWeight:"bold", textDecoration:"underline"}}>Thermal Transfer Over Printers</div>
          <nav className="nav flex-column">
            <button
              className={`nav-link ${activeComponent === '32I&C-TTO' ? 'active' : ''}`}
              onClick={() => handleComponentChange('32I&C-TTO')}
            >
               32 I & C TTO
            </button>
            <button
              className={`nav-link ${activeComponent === '53I&C-TTO' ? 'active' : ''}`}
              onClick={() => handleComponentChange('53I&C-TTO')}
            >
             53 I & C TTO    
            </button>
            <button
              className={`nav-link ${activeComponent === '107I&C-TTO' ? 'active' : ''}`}
              onClick={() => handleComponentChange('107I&C-TTO')}
            >
             107 I & C TTO
            </button>
            <button
              className={`nav-link ${activeComponent === '128I&C-TTO' ? 'active' : ''}`}
              onClick={() => handleComponentChange('128I&C-TTO')}
            >
              128 I & C TTO
            </button>
          </nav>
        </div>

        {/* Main Content Area */}
        <div className="main-content">
          {renderActiveComponent()}
        </div>
      </div>
    </div>
  );
};

export default TTOLayout;